var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn",class:_vm.getClass,domProps:{"innerHTML":_vm._s(_vm.getText)},on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }